import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const BackIcon = (props) => (
  <SvgIcon {...props}>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      5,5 1,12 5,19 "/>
  </SvgIcon>
);

export default BackIcon;



// WEBPACK FOOTER //
// ./src/icons/BackIcon.jsx